import React from 'react';
import { useSearchParams } from 'react-router-dom';
import AppShell from '../components/AppShell';
import PreferencesTab from '../components/dash/PreferencesTab';
import { useMe, useFlash } from '../lib/useMe';

export default function PreferencesPage() {
  const [me, setMe] = useMe();
  const flash = useFlash();
  const [params] = useSearchParams();
  if (!me) return <AppShell title="Match Preferences"><p style={{ color: 'var(--muted)' }}>Loading…</p></AppShell>;
  return (
    <AppShell
      title="Match Preferences"
      subtitle="Tell Krysha what matters to you — we use this to line up the profiles in Connect."
      testid="preferences-page"
    >
      <PreferencesTab me={me} setMe={setMe} flash={flash} startEdit={params.get('edit') === '1'} />
    </AppShell>
  );
}
